module.exports = __webpack_public_path__ + "static/blackunderline-5a92aa838e1cff700e1830cf229c8ac2.png";